export default {
  FormState: {
    Add: "Thêm mới",
    View: "Xem",
    Edit: "Sửa",
    Duplicate: "Nhân bản",
    QuickAdd: "Thêm nhanh",
  },
  /**
   * Trạng thái đơn vị JetPay
   * 0:Đăng ký Merchant
   * 1:Đang nộp hồ sơ
   * 2:Đang cập nhật thông tin bổ sung cho phần rủi ro
   * 3:Chờ kinh doanh phê duyệt
   * 4:Kinh doanh từ chối
   * 5:Chờ giám sát vận hành phê duyệt
   * 6:Giám sát vận hành từ chối
   * 7:Chờ giám đốc phê duyệt
   * 8:Giám đốc từ chối
   * 9:Phê duyệt
   * 10: Chờ pháp chế phê duyệt
   * 11: Pháp chế yêu cầu cập nhật
   * 12: NVKD tiếp nhận
   * 13: Hủy bỏ (NVKD hủy bỏ tại trường hợp mà hồ sơ đăng ký mới nhưng k còn nhu cầu hoặc không liên lạc được)
   */
  MerchantStatus: {
    RegisterNew: "Đăng ký mới",
    Applying: "Đang nộp hồ sơ",
    UpdatingRiskInfo: "Chờ khách hàng cập nhật",
    WaitingEmployeeApprove: "Chờ kinh doanh phê duyệt",
    EmployeeDecline: "Hồ sơ bị hủy",
    WaitingMonitorApprove: "Chờ giám sát phê duyệt",
    MonitorDecline: "Giám sát yêu cầu cập nhật",
    WaitingManagerApprove: "Chờ giám đốc phê duyệt",
    ManagerDecline: "Giám đốc yêu cầu cập nhật",
    Approve: "Phê duyệt",
    WaitingLegislationApprove: "Chờ pháp chế phê duyệt",
    LegislationDecline: "Pháp chế yêu cầu cập nhật",
    SaleReceived: "NVKD Tiếp nhận", // NVKD Tiếp nhận hồ sơ
    TemporarilyLocked: "Tạm khóa", // Tạm khóa
    StopWorking: "Ngừng hoạt động", // Ngừng hoạt động
  },
  /**
   * Loại dịch vụ
   */
  BusinessType: {
    Normal: "Dịch vụ thường",
    Special: "Dịch vụ đặc thù",
    PublicService: " Dịch vụ công",
  },
  BusinessServiceType: {
    Normal: "Dịch vụ thường",
    Special: "Dịch vụ đặc thù",
    PublicService: " Dịch vụ công",
  },

  // Trạng thái hoạt động của hồ sơ
  // 0: Ngừng hoạt động
  // 1: đang hoạt động,
  // 2: Tạm khoá,
  MerchantIsActive: {
    IsActive: "Đang hoạt động",
    TemporarilyLocked: "Tạm khoá",
    StopWorking: "Ngừng hoạt động",
    WaitingForAccountLevel: "Chờ cấp tài khoản",
  },
  /**
   * Modify by ĐVThi 08/03/2021
   * Làm chuẩn lại danh sách trạng thái theo tài liệu chuẩn của BA
   */
  AssetStatus: {
    UnUse: "Chưa sử dụng",
    Use: "Đang sử dụng",
    ReportBroken: "Báo hỏng",
    Broken: "Đã hỏng",
    Repair: "Đang sửa chữa",
    Maintain: "Đang bảo dưỡng",
    ReportLost: "Báo mất",
    Lost: "Đã mất",
    Cancel: "Đã hủy",
    RequestLiquidation: "Đề nghị thanh lý",
    Liquidated: "Đã thanh lý",
    Tranfering: "Đang điều chuyển",
  },
  RoleCategoryMerchant: {
    MerchantAdmin: "MerchantAdmin",
    TransactionManagement: "Merchant_TransactionManagement",
    ControlManagement: "Merchant_ControlManagement",
    Paymentlink: "Merchant_Paymentlink",
    ComplaintAndRefund: "Merchant_ComplaintAndRefund",
    Setting: "Merchant_Setting",
    UpdateRequest: "Merchant_RequestUpdate",
    ProfileInfo: "Merchant_ProfileInfo",
  },
  PickListType: {
    JobRole: "Vai trò công việc",
    Title: "Chức danh",
    Unit: "Đơn vị tính",
    AssetRoot: "Nguồn gốc",
  },
  AuditingLogAction: {
    Login: "Đăng nhập",
    Logout: "Đăng xuất",
    Insert: "Thêm",
    Edit: "Sửa",
    Delete: "Xóa",
    Cancel: "Hủy tài sản",
    ReUse: "Đưa tài sản về sử dụng",
    Maintain: "Bảo dưỡng tài sản",
    Repair: "Sửa chữa tài sản",
    ToStock: "Đưa tài sản vào kho",
    Transfer: "Điều chuyển",
    Increases: "Ghi tăng tài sản",
    MultiDisposal: "Đánh dấu mất hàng loạt",
    Disposal: "Đánh dấu mất",
    MultiBroken: "Đánh dấu hỏng hàng lọa",
    Reduce: "Thu hồi",
    Allocation: "Cấp phát",
  },
  OrganizationUnitType: {
    Corporations: "Tổng công ty",
    Group: "Tập đoàn",
    Subsidiaries: "Công ty con",
    Branch: "Chi nhánh",
    Representative: "Văn phòng đại điện",
    Office: "Văn phòng",
    Center: "Trung tâm",
    Department: "Phòng ban",
    Team: "NHóm/tổ/đội",
    Factory: "Phân xưởng",
  },
  ImportType: {
    Asset: "Tai_san",
    AssetInUse: "Tai_san_dang_su_dung",
    JobPosition: "Vi_tri_cong_viec",
    AssetType: "Loai_tai_san",
    AssetCategory: "Nhom_tai_san",
    Provider: "Nha_cung_cap",
    Location: "Vi_tri_tai_san",
    PaymentRequest: "Nhập khẩu yêu cầu thanh toán",
  },

  GenderType: {
    Female: "Nữ",
    Male: "Nam",
  },

  /**
   * Loại thẻ
   */
  PaymentType: {
    LocalCard: "Thẻ ATM nội địa",
    Visa: "Thẻ quốc tế",
    BankAccount: "Thu hộ",
    Wallet: "Ví điện tử",
    QRCode: "Mã QR",
    Momo: "Ví Momo",
    ViettelMoney: "ViettelMoney",
    ZaloPay: "ZaloPay",
    Transfer: "Chuyển khoản",
    ShopeePay: "ShopeePay",
    AgribankAccount: "Tài khoản Agribank",
  },

  /**
   * Mã dịch vụ đối tác
   */
  PartnerCodeService: {
    TuitionSacombank: "STB",
    TuitionBIDV: "BIDV",
    TuitionVietcombank: "VCB",
  },

  /**
   * Cấp học
   */
  SchoolLevel: {
    Other: "Khác", // Khác
    Preschool: "Mầm non", // Mầm non
    PrimarySchool: "Tiểu học", // Tiểu học
    SecondarySchool: "THCS", // THCS
    HighSchool: "THPT", // THPT
    InterLevelSchool: "Liên cấp", // Liên cấp
    KinderGarten: "Mẫu giáo", // Mẫu giáo
    EduCenter: "Trung tâm GDTX - GDNN",
    CollegeUniversity: "Cao đẳng, đại học",
  },

  /**
   * Loại thẻ
   */

  TransactionStatus: {
    All: "Tất cả",
    // Request: "Yêu cầu thanh toán",
    Pending: "Chờ thanh toán",
    Failed: "Thất bại",
    Success: "Thành công",
    Expiration: "Hết hạn thanh toán",
    Cancel: "Hủy giao dịch",
    RefundFailed: "Hoàn tiền thất bại",
    PendingRefund: "Chờ hoàn tiền",
    Refunded: "Đã hoàn tiền",
    Waitting: "Chờ xử lý",
  },

  UserStatus: {
    Pendding: "Chờ phê duyệt",
    Active: "Đang hoạt động",
    NoActive: "Ngừng hoạt động",
  },

  RoleUser: {
    Admin: "Admin",
    User: "Người dùng",
  },

  /**
   * Loai merchant
   */
  MerchantType: {
    None: "-",
    School: "Trường học (Công lập)",
    PrivateSchool: "Trường học (Tư thục)",
    Enterprise: "Doanh nghiệp",
    Store: "Cửa hàng",
    Restaurant: "Nhà hàng",
    Other: "Khác",
  },

  /**
   * Trạng thái hoàn tiền
   */
  RefundStatus: {
    All: "Tất cả",
    PendingRefund: "Chờ hoàn tiền",
    Refunded: "Đã hoàn tiền",
    RefundFailed: "Hoàn tiền thất bại",
  },
  /**
   * Loại dịch vụ
   */
  TypeService: {
    All: "Tất cả",
    PaymentGate: "Cổng thanh toán",
    Billing: "Thu hộ",
    Transfer: "Chuyển khoản",
  },

  //pvduy 05/02/2020 loại lịch bảo dưỡng, sửa chữa
  ScheduleType: {
    //sửa chưa
    Repain: "Sửa chữa",
    //bảo dưỡng
    Maintenance: "Bảo dưỡng",
  },
  //pvduy 05/02/2020 trạng thái bảo dưỡng, sửa chữa
  ScheduleStatus: {
    // kế hoạch
    Plan: "Kế hoạch",
    // đang thực hiện
    Process: "Đang thực hiện",
    // hoàn thành
    Done: "Hoàn thành",
  },
  OccurrenceType: {
    //Ghi tăng
    Increament: "Ghi tăng",
    //Cấp phát
    Allocation: "Cấp phát",
    //Thu hồi
    Reduce: "Thu hồi",
    //Bảo dưỡng
    Maintain: "Bảo dưỡng",
    // Sửa chữa
    Repair: "Sửa chữa",
    //Mất
    Lost: "Mất",
    //hỏng
    Broken: "Hỏng",
    //Hủy
    Cancel: "Hủy",
    // thanh lý
    Liquidation: "Thanh lý",
    // thay đổi vị trí
    ChangeAssetLocation: "Thay đổi vị trí",
    // đưa vào sử dụng lại
    ReUse: "Đưa vào sử dụng lại",
    // đề nghị thanh lý
    RequestLiquidation: "Đề nghị thanh lý",
    // Từ chối báo hỏng
    DenyBroken: "Từ chối báo hỏng",
    //Ghi tăng số lượng
    IncrementQuantity: "Ghi tăng số lượng",
    //Điều chuyển vị trí
    TransferLocation: "Điều chuyển vị trí tài sản",
    //Điều chuyển đối tượng sử dụng
    TransferObject: "Điều chuyển đối tượng sử dụng",
    //Điều chuyển đi -Đang điều chuyển(Đơn vị quản lý)
    TransferManager: "Điều chuyển đơn vị quản lý",
    //Điều chuyển từ chối (Đơn vị quản lý)
    TransferManagerRefuse: "Từ chối TS điều chuyển",
    //Điều chuyển nhận tài sản (Đơn vị quản lý)
    TransferManagerAccept: "Nhận TS điều chuyển",
  },
  /**
   * ĐVThi
   * Quy tắc đánh mã trên loại tài sản
   */
  EnumCodeType: {
    Company: "Tăng theo quy tắc chung toàn công ty",
    Branch: "Tăng theo từng phòng ban, chi nhánh",
    Manual: "Tự nhập mã",
  },
  EnumUnit: {
    Month: "Tháng",
    Year: "Năm",
  },
  /**
   * ĐVThi
   * Cách quản lý tài sản
   */
  EnumByQuantity: {
    Code: "Quản lý theo mã",
    Quantity: "Quản lý theo số lượng",
  },
  EnumWarranty: {
    NopeWarranty: "Không có bảo hành",
    Warranty: "Được bảo hành",
  },
  EnumMaintenance: {
    NopeMaintenance: "Không bảo dưỡng",
    Maintenance: "Bảo dưỡng định kỳ",
  },

  EnumInActive: {
    Active: "Đang theo dõi",
    InActive: "Ngừng theo dõi",
  },
  EnumGender: {
    Male: "Nam",
    Female: "Nữ",
  },
  /**
   * pvduy 22/02/2021
   * Enum combobox đơn vị thời gian
   */
  EnumTimeUnit: {
    Month: "Tháng",
    Year: "Năm",
  },
  /**
   * pvduy 22/02/2021
   * Enum combobox cấp phát theo
   */
  AllocationType: {
    //Cấp phát theo nhân viên
    AllocationByEmployee: "Nhân viên",
    //Cấp phát theo phòng ban
    AllocationByOrganization: "Phòng ban",
  },
  /**
   * toán tử filter
   */
  FilterHeader: {
    Contains: "Chứa",
    Notcontains: "Không chứa",
    StartsWith: "Bắt đầu với",
    EndsWith: "Kết thúc với",
    Null: "(Trống)",
    NotNull: "(Không trống)",
    Equals: "Bằng",
    NotEquals: "Khác",
    GreaterThan: "Lớn hơn",
    GreaterThanEquals: "Lớn hơn hoặc bằng",
    LessThan: "Nhỏ hơn",
    LessThanEquals: "Nhỏ hơn hoặc bằng",
    Between: "Trong khoảng",
  },
  CustomFieldType: {
    Text: "Kiểu chữ",
    Number: "Kiểu số",
    Bool: "Kiểu tích chọn",
    Date: "Kiểu ngày",
    Time: "Kiểu giờ",
    List: "Danh sách",
  },
  /*
    Trạng thái điều chuyển
  */
  TransferStatus: {
    Transfering: "Đang điều chuyển",
    Received: "Đã nhận tài sản",
    Cancelled: "Từ chối",
  },
  /*
    Trạng thái kiểm kê
  */
  AuditStatus: {
    New: "Chưa thực hiện",
    Processing: "Đang thực hiện",
    Done: "Đã thực hiện",
  },
  /*
Trạng thái kiểm kê của tài sản
*/
  AssetAuditStatus: {
    New: "Chưa kiểm kê",
    Done: "Đã kiểm kê",
  },

  /*
    Loại kiểm kê
  */
  AuditType: {
    Detail: "Chi tiết", //Kiểm kê chi tiết
    Quantity: "Số lượng", //Kiểm kê số lượng
  },
  /*
  Thay đổi detail kiểm kê
*/
  AuditChange: {
    NoChange: "",
    Changed: "x",
  },

  AuditAssetQuality: {
    Good: "Sử dụng tốt",
    Repair: "Hỏng cần sửa chữa",
    Liquidation: "Hỏng cần thanh lý",
  },
  /*
   * combobox trạng thái
   * pvduy 03/01/2021
   */
  StatusCombobox: {
    Active: "Đang theo dõi", // đang theo dõi
    Inactive: "Ngừng theo dõi", // ngừng theo dõi
    All: "Tất cả", // tất cả
  },

  /*
   * Enum trạng thái của đơn vi
   * nvhai 28/03/2021
   */
  OrganizationUnitStatus: {
    all: "Tất cả", // Tất cả
    Inactive: "Ngừng theo dõi", // Ngừng theo dõi
    Active: "Đang theo dõi", // Đang theo dõi
  },

  /**
   * Trạng thái lao động
   * */
  EmployeeStatus: {
    /**
     * Đang làm việc
     */
    Working: "Đang làm việc",
    /**
     * Đã nghỉ việc
     */
    Quit: "Đã nghỉ việc",
    /**
     * Ngừng theo dõi
     */
    NotFollowing: "Ngừng theo dõi",
  },

  Period: {
    ThisDay: "Hôm nay",
    ThisWeek: "Tuần này",
    FirstWeekToPresent: "Đầu tuần tới hiện tại",
    ThisMonth: "Tháng này",
    FirstMonthToPresent: "Đầu tháng tới hiện tại",
    ThisQuarter: "Quý này",
    FirstQuarterToPresent: "Đầu quý tới hiện tại",
    ThisYear: "Năm nay",
    FirstYearToPresent: "Đầu năm tới hiện tại",
    SixFirstMonth: "Sáu tháng đầu năm",
    SixLastMonth: "Sáu tháng cuối năm",
    January: "Tháng 1",
    February: "Tháng 2",
    March: "Tháng 3",
    April: "Tháng 4",
    May: "Tháng 5",
    June: "Tháng 6",
    July: "Tháng 7",
    August: "Tháng 8",
    September: "Tháng 9",
    October: "Tháng 10",
    November: "Tháng 11",
    December: "Tháng 12",
    FiscalI: "Quý 1",
    FiscalII: "Quý 2",
    FiscalIII: "Quý 3",
    FiscalIV: "Quý 4",
    Yesterday: "Hôm qua",
    LastWeek: "Tuần trước",
    LastMonth: "Tháng trước",
    LastQuarter: "Quý trước",
    LastYear: "Năm trước",
    Tomorrow: "Ngày mai",
    NextWeek: "Tuần sau",
    NextMonth: "Tháng sau",
    NextQuarter: "Quý sau",
    NextYear: "Năm sau",
    Custom: "Tùy chọn",
  },
  /**
   * Các loại kỳ báo cáo
   */
  PeriodType: {
    Month: "Tháng",
    Quarter: "Quý",
    Year: "Năm",
  },

  /*
   * Chọn khổ giấy
   * CreatedBy nnlam 20.04.2021
   */
  ChoosePageType: {
    A4_65: "Khổ A4 - 65 tem (Khổ 210x297 mm, Tomy 145)",
    A5_40: "Khổ A5 - 40 tem (Khổ 202x168mm, Tomy 108)",
    TwoTem: "Khổ cuộn 2 tem (72mm)",
    ThreeTem: "Khổ cuộn 3 tem (110mm)",
    Tze251: "Cuộn Tze251 24mm",
    A4_21: "Khổ A4 - 21 tem (Tomy 135)",
    A4_24: "Khổ A4 - 24 tem (Tomy 136)",
    TzeS261: "Cuộn TzeS261 36mm",
  },

  /**
   * Chọn loại đơn vị trong báo cáo theo đơn vị
   * CreatedBy: NTAnh2 (22/04/2021)
   */
  ReportUnitType: {
    Management: "Đơn vị quản lý",
    UseOrg: "Đơn vị sử dụng",
  },

  /**
   * Chọn nhóm trạng thái tài sản trong báo cáo theo đơn vị
   * CreatedBy: NTAnh2 (22/04/2021)
   */
  GroupAssetStatus: {
    // tất cả trạng thái
    All: "Tất cả",
    // đang sử dụng
    Use: "Đang sử dụng",
    // chưa sử dụng
    UnUse: "Chưa sử dụng",
    // đã hỏng, đang sửa chữa, đang bảo dưỡng
    GroupBrokenRepairMaintain: "Đã hỏng, đang sửa chữa, đang bảo dưỡng",
    // đã mất, đã hủy, đã thanh lý
    GroupLostCancelLiquidated: "Đã mất, đã hủy, đã thanh lý",
    // khác (báo hỏng, báo mất, đề nghị thanh lý, đang điều chuyển)
    Other: "Khác",
  },

  /**
   * Trạng thái người dùng bên amis paltform
   * */
  UserAmisStatus: {
    /**
     * chưa kích hoạt
     */
    NotActiviti: "Chưa kích hoạt",
    /**
     * chờ xác nhận
     */
    WaitConfirm: "Chờ xác nhận",
    /**
     * Đang hoạt động
     */
    Working: "Đang hoạt động",
    /**
     * Ngừng kích hoạt
     */
    NotFollowing: "Ngừng kích hoạt",
    /**
     * Đã bị xóa
     */
    Deleted: "Đã bị xóa",
  },

  /**
   * Tháng
   */
  EnumMonth: {
    January: "Tháng 1",
    February: "Tháng 2",
    March: "Tháng 3",
    April: "Tháng 4",
    May: "Tháng 5",
    June: "Tháng 6",
    July: "Tháng 7",
    August: "Tháng 8",
    September: "Tháng 9",
    October: "Tháng 10",
    November: "Tháng 11",
    December: "Tháng 12",
  },

  /**
   * Kiểm kê
   */
  EnumAuditStatus: {
    None: "Chưa kiểm kê",
    Auditing: "Đang kiểm kê",
    Done: "Đã thực hiện",
  },

  /**
   * Trạng thái người dùng Amis
   */
  AmisUserStatus: {
    NotTriggered: "Chưa kích hoạt",
    WaitConfirm: "Chờ xác nhận",
    Working: "Đang hoạt động",
    StopTriggered: "Ngừng kích hoạt",
  },

  /*
   * Nhóm theo cột màn hình chi tiết kiểm kê
   */
  GroupType: {
    // Loại tài sản
    AssetType: "Loại tài sản",
    // Vị trí tài sản
    Location: "Vị trí tài sản",
    // Phòng ban sử dụng
    OrganizationUnit: "Phòng ban sử dụng",
  },

  /**
   * Tình trạng xử lý (kiểm kê)
   */
  StatusResolve: {
    // Chưa xử lý
    NotResolve: "Chưa xử lý",
    // Đã xử lý
    Resolved: "Đã xử lý",
  },

  /**
   * Chất lượng tài sản thực tế (kiểm kê)
   */
  QualityReal: {
    // Sử dụng tốt
    Good: "Sử dụng tốt",
    // Hỏng cần sửa chữa
    BrokenRepair: "Hỏng cần sửa chữa",
    // Hỏng cần thanh lý
    BrokenLiquidation: "Hỏng cần thanh lý",
  },

  /**
   * Enum trang thái giao dịch thanh toán
   */
  TransactionControlType: {
    PaymentRequired: "Yêu cầu thanh toán",
    HandlingTransaction: "Đang xử lý",
    PaymentFail: "Thất bại",
    PaymentSuccess: "Thành công",
    PaymentExpired: "Hết hạn",
    PaymentCancle: "Hủy giao dịch",
  },

  /**
   * Enum trang thái đối soát
   */
  CrossCheckingType: {
    Processing: "Chưa đối soát",
    Done: "Đã đối soát",
  },
  /**
   * Enum trang thái đối soát theo tháng
   */
  CrossCheckingTypeByMonth: {
    Processing: "Chưa xác nhận",
    Done: "Đã xác nhận",
  },

  /**
   * Loại chức vụ
   */
  JobTitle: {
    /**
     * Chủ tịch hội đồng quản trị
     */
    President: "Chủ tịch hội đồng quản trị",

    /**
     * Phó chủ tịch hội đồng quản trị
     */
    VicePresident: "Phó chủ tịch hội đồng quản trị",

    /**
     *  Tổng giám đốc
     */
    GeneralDirector: "Tổng giám đốc",

    /**
     * Phó tổng giám đốc
     */
    DeputyGeneralDirector: "Phó tổng giám đốc",

    /**
     * Giám đốc
     */
    Director: "Giám đốc",

    /**
     * Phó giám đốc
     */
    DeputyDirector: "Phó giám đốc",

    /**
     * Kế Toán trưởng
     */
    ChiefAccountant: "Kế Toán trưởng",
  },

  //Loại thông tin đơn vị
  OrgType: {
    //Công ty mẹ
    ParentCompany: "Công ty mẹ",
    //Chi nhánh
    Branch: "Chi nhánh",
    //Công ty con
    Subsidiary: "Công ty con",
    //văn phòng đại diện.
    RepresentativeOffice: "Văn phòng đại diện",
  },

  // Loại giấy tờ
  CitizenType: {
    // căn cước công dân
    CCCD: "Căn cước công dân",

    // chứng minh nhân dân
    CMND: "Chứng minh nhân dân",

    // hộ chiếu
    Passport: "Hộ chiếu",
  },

  //Trạng thái của payment link
  PaymentLinkStatus: {
    //Chờ thanh toán
    WaitForPay: "Chờ thanh toán",
    //Đã thanh toán
    Paid: "Đã thanh toán",
    //Hết hạn
    Expired: "Hết hạn",
  },

  //Loại link paymentlink

  PaymentLinkType: {
    //Link mua hàng
    PurchaseLink: "Link mua hàng",
    //Link thanh toán hóa đơn
    BillPaymentLink: "Link thanh toán hóa đơn",
  },

  /**
   * Trạng thái của yêu cầu thanh toán
   */
  PaymentRequestStatus: {
    Create: "Chưa thông báo",
    Sent: "Đã thông báo",
    Open: "Đã mở YCTT",
    Expired: "Đã quá hạn",
    Proscess: "YCTT đang được thực hiện",
    Paid: "Đã thanh toán",
    PaidFail: "Thanh toán thất bại",
    Edited: "Đã sửa YCTT",
    PaidJetPay: "Đã thanh toán",
  },
  /**
   * Loại khách hàng
   */
  CustomerType: {
    Individual: "Cá nhân",
    Organization: "Tổ chức",
    OrgUndefined: "-",
  },
  /**
   * Trạng thái khoản thu
   */
  CollectionPeriodStatus: {
    Create: "Đã tạo",
    Processing: "Đang thu",
    Done: "Đã thu đủ",
  },
  ImportStatus: {
    Valid: "Hợp lệ",
    Invalid: "Không hợp lệ",
  },
  // Trạn thái đối soát thanh toán cho merchant
  MerchantTransactionControlStatus: {
    NotConfirm: "Chưa chốt số liệu",
    UnPaid: "Chưa thanh toán",
    Paid: "Đã thanh toán",
    Confirming: "Đang xác nhận đối soát",
  },
  MerchantTransactionSettlementStatus: {
    // chưa đối soát
    UnContested: "Chưa đối soát",
    // đã đối soát
    Contested: "Đã đối soát",
  },
  MerchantTransactionControlTransactionType: {
    Success: "Giao dịch thành công",
    SuccessPrevious: "Giao dịch kỳ trước thành công kỳ này",
    Compensate: "Giao dịch bù trừ", // bù trừ
    SuspectedFraud: "Giao dịch nghi ngờ gian lận",
    Cheat: "Giao dịch gian lận",
    AppealAgain: "Giao dịch khiếu nại",
    Refund: "Giao dịch hoàn trả",
  },
  /**Tiền đang ở */
  StatusMoney: {
    Partner: "Đối tác",
    JETPAY: "JETPAY",
    Merchant: "ĐVCNTT",
  },

  /**
   * Loại giấy tờ căn cước
   */
  IdCardType: {
    CCCD: "Căn cước công dân",
    CC: "Căn cước",
  },
};
